<template>
  <div>
    <transfer v-if="serviceType === 'airporttransfer'" />
    <rental v-else-if="serviceType === 'rental'" />
  </div>
</template>

<script>
import transfer from "@/components/availability/result/inquiry/ResultTransfer";
import rental from "@/components/availability/result/inquiry/ResultRental";

export default {
  components: {
    transfer,
    rental,
  },
  computed: {
    serviceType: function () {
      return this.$route.query.svc.toLowerCase();
    },
  },
  beforeDestroy() {
    localStorage.removeItem("reservationRequest");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/availability/result/inquiry/Result.vue